import { t as e } from "./cx-BjmrJCen.js";
/* empty css                              */
import { jsx as t, jsxs as n } from "react/jsx-runtime";
//#region src/components/app-shell/app-shell.css.ts
var r = "_1fqahx0", i = "_1fqahx1", a = "_1fqahx2", o = "_1fqahx3", s = "_1fqahx4", c = "_1fqahx5", l = "_1fqahx6", u = "_1fqahx7", d = "_1fqahx8", f = "_1fqahx9", p = "_1fqahxa", m = "_1fqahxb", h = "_1fqahxc", g = "_1fqahxd", _ = "_1fqahxe", v = "_1fqahxf", y = "_1fqahxg", b = "_1fqahxi", x = "_1fqahxj", S = "_1fqahxk", C = "_1fqahxl", w = "_1fqahxm", T = "_1fqahxn";
//#endregion
//#region src/components/app-shell/app-shell.tsx
function E({ children: n, className: i, ...a }) {
	return /* @__PURE__ */ t("main", {
		...a,
		className: e(r, i),
		children: n
	});
}
function D({ children: n, className: r, ...a }) {
	return /* @__PURE__ */ t("header", {
		...a,
		className: e(i, r),
		children: n
	});
}
function O({ children: n, className: r, ...i }) {
	return /* @__PURE__ */ t("button", {
		...i,
		className: e(a, r),
		children: n
	});
}
function k({ children: n, className: r, ...i }) {
	return /* @__PURE__ */ t("div", {
		...i,
		className: e(o, r),
		children: n
	});
}
function A({ badge: r, children: i, className: a, ...o }) {
	return /* @__PURE__ */ n("button", {
		...o,
		className: e(s, a),
		children: [i, r == null ? null : /* @__PURE__ */ t("span", {
			className: c,
			children: r
		})]
	});
}
function j({ children: n, className: r, ...i }) {
	return /* @__PURE__ */ t("section", {
		...i,
		className: e(l, r),
		children: n
	});
}
function M({ children: n, className: r, ...i }) {
	return /* @__PURE__ */ t("button", {
		...i,
		className: e(u, r),
		children: n
	});
}
function N({ children: n, className: r, ...i }) {
	return /* @__PURE__ */ t("div", {
		...i,
		className: e(d, r),
		children: n
	});
}
function P({ children: n, className: r, ...i }) {
	return /* @__PURE__ */ t("aside", {
		...i,
		className: e(f, r),
		children: n
	});
}
function F({ children: n, className: r, ...i }) {
	return /* @__PURE__ */ t("nav", {
		...i,
		className: e(p, r),
		children: n
	});
}
function I({ children: n, className: r, ...i }) {
	return /* @__PURE__ */ t("div", {
		...i,
		className: e(m, r),
		children: n
	});
}
function L({ children: r, className: i, icon: a, open: o = !0, type: s, ...c }) {
	return /* @__PURE__ */ n("button", {
		...c,
		className: e(h, i),
		type: s ?? "button",
		children: [
			/* @__PURE__ */ t("span", {
				className: g,
				children: a
			}),
			/* @__PURE__ */ t("span", { children: r }),
			/* @__PURE__ */ t("span", {
				className: _,
				children: o ? "⌃" : "⌄"
			})
		]
	});
}
function R({ children: n, className: r, ...i }) {
	return /* @__PURE__ */ t("div", {
		...i,
		className: e(v, r),
		children: n
	});
}
function z({ active: r = !1, children: i, className: a, color: o = "#ffffff", count: s, icon: c, style: l, type: u, ...d }) {
	let f = {
		...l,
		"--taskguard-nav-color": o
	};
	return /* @__PURE__ */ n("button", {
		...d,
		className: e(y, r && "_1fqahxh", a),
		style: f,
		type: u ?? "button",
		children: [
			/* @__PURE__ */ t("span", {
				className: b,
				children: c
			}),
			/* @__PURE__ */ t("span", {
				className: S,
				children: i
			}),
			s == null ? null : /* @__PURE__ */ t("span", {
				className: x,
				children: s
			})
		]
	});
}
function B({ children: n, className: r, ...i }) {
	return /* @__PURE__ */ t("div", {
		...i,
		className: e(C, r),
		children: n
	});
}
function V({ children: n, className: r, ...i }) {
	return /* @__PURE__ */ t("div", {
		...i,
		className: e(w, r),
		children: n
	});
}
function H({ children: n, className: r, ...i }) {
	return /* @__PURE__ */ t("section", {
		...i,
		className: e(T, r),
		children: n
	});
}
//#endregion
export { E as AppFrame, j as InstallBanner, M as InstallButton, P as Sidebar, V as SidebarDeviceCard, B as SidebarFooter, I as SidebarGroup, L as SidebarGroupHeader, R as SidebarMenu, z as SidebarMenuButton, F as SidebarNav, D as Topbar, k as TopbarActions, O as TopbarBrandButton, A as TopbarIconButton, N as VaultSwitcherField, H as WorkspaceShell };

//# sourceMappingURL=app-shell.js.map